import ColorThief from 'colorthief/dist/color-thief.umd';

// Mirrors picking the logo's dominant colour at 4% opacity over a white background, then reading the hex off it.
const TINT_OPACITY = 0.04;
const toHex = (value: number) => Math.round(value).toString(16).padStart(2, '0');
const tintOverWhite = (channel: number) => channel * TINT_OPACITY + 255 * (1 - TINT_OPACITY);

export const getLogoBackgroundColor = ({
  logoUrl,
  replacementOfUrl,
}: {
  logoUrl: string;
  replacementOfUrl: (params: { url: string }) => string;
}) =>
  new Promise<string | null>((resolve) => {
    const img = new Image();
    img.addEventListener('load', () => {
      const ct = new ColorThief();
      const [r, g, b] = ct.getColor(img, 10);
      resolve(`#${[r, g, b].map((channel) => toHex(tintOverWhite(channel))).join('')}`);
    });
    img.addEventListener('error', () => resolve(null));
    img.crossOrigin = 'anonymous';
    img.src = replacementOfUrl({ url: logoUrl });
  });
